import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PropTypes from 'prop-types';
import AccountPopover from './AccountPopover';
import LocalePopover from './LocalePopover';
import { FormattedMessage } from 'react-intl';
import { useAuth } from '../../../contexts/authContext';

export default function NavBar({ onDrawerToggle, drawerWidth, isMobileOrSmallDesktop }) {

  const auth = useAuth();

  const sxs = useMemo(() => {
    let appBarSX = {};
    let iconButtonSX = { mr: 2 };
    if (!isMobileOrSmallDesktop) {
      appBarSX = { width: { md: `calc(100% - ${drawerWidth}px)` }, ml: { md: `${drawerWidth}px` } };
      iconButtonSX = { ...iconButtonSX, display: { md: 'none' } };
    }
    return { appBarSX, iconButtonSX };
  }, [isMobileOrSmallDesktop]);

  return (
    <AppBar
      position="fixed"
      sx={sxs.appBarSX}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerToggle}
          sx={sxs.iconButtonSX}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <FormattedMessage id={auth.user.isActive == 0 ? 'navbar.inactive' : 'navbar.title'} defaultMessage='Just do it!' />
        </Typography>
        <IconButton
          color="inherit"
          component={Link}
          to="/dashboard/release-notes"
          aria-label="view release notes"
        >
          <HelpOutlineIcon />
        </IconButton>
        <LocalePopover />
        <AccountPopover />
      </Toolbar>
    </AppBar>
  );
}

NavBar.propTypes = {
  isMobileOrSmallDesktop: PropTypes.bool,
  drawerWidth: PropTypes.number.isRequired,
  mobileOpen: PropTypes.bool,
  onDrawerToggle: PropTypes.func
};